import { DifficultyConstants } from "../Constants/DifficultyConstants";
import { PlayerTypeConstants } from "../Constants/PlayerTypeConstants";
import { IScoreLogItem } from "./GameModel";
export class PlayerModel {
    public x: number = -210; // в пикселях относительно жкрана
    public y: number = 0; // в пикселях относительно жкрана
    public x3d: number = 0; // растояние по оси х (в мм)
    public z3d: number = 0; // растояние на котором стоит игрок от кюкей (в мм)
    public power: number = 1;
    public anglePower: number = 0.5;
    public angleX: number = 0;
    public angleY: number = 0;
    public hits: number = 0; // колличество совершенных бросков
    public scoresLog: IScoreLogItem[] = [];
    public roundsScoresLog: number[] = []; // история очков за раунды за раунды
    public active: boolean = false; // текущий ход
    public kykkaTouched: boolean = false; // была ли сбита хоть одна кюка
    public behindCamera: boolean = false; // камера в режиме Zoom (игрок скрыт)
    public difficulty: DifficultyConstants = DifficultyConstants.Easy;
    public isRightHand: boolean = true;

    constructor(public type: PlayerTypeConstants = PlayerTypeConstants.Man) {

    }

    get scores() {
        return this.scoresLog[0] ? this.scoresLog[0].total : 0;
    }
}